import { render, staticRenderFns } from "./ApercuPanier.vue?vue&type=template&id=053153aa&scoped=true&"
import script from "./ApercuPanier.js?vue&type=script&lang=js&"
export * from "./ApercuPanier.js?vue&type=script&lang=js&"
import style0 from "./ApercuPanier.scoped.scss?vue&type=style&index=0&id=053153aa&lang=scss&scoped=true&"
import style1 from "./ApercuPanier.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053153aa",
  null
  
)

export default component.exports